module.exports = __webpack_public_path__ + "static/img/Bachelor_010743.342cdec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010743.jpg
// module id = 241
// module chunks = 0